










import UnderConstruction from "@/components/UnderConstruction.vue"
import { Vue, Component } from "vue-property-decorator"

@Component({
  name: "Dashboard",
  components: {
    "under-construction": UnderConstruction,
  },
})
export default class Dashboard extends Vue {}
